// @ts-nocheck
import React, { useEffect, useState } from "react";
import {
  FormLabel,
  FormControl,
  Input,
  Button,
  Flex,
  Center,
  Text,
  Box,
  useToast,
  FormErrorMessage,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import {
  useRecoveryAccountMutation,
  useResetPasswordMutation,
} from "redux/services/identity";
import * as yup from "yup";
import { useHistory } from "react-router-dom";

export const emailSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
});

const Forgot = () => {
  const {
    formState: { isSubmitting },
  } = useForm();
  const toast = useToast();
  const { push } = useHistory();

  const [formData, setFormData] = useState({
    email: "",
  });

  const [
    recovery,
    { isSuccess, isError, error: errorRecovery, data: recoveryData, isLoading },
  ] = useRecoveryAccountMutation();

  const [
    resetPasswordMutation,
    {
      isLoading: isResetPasswordLoading,
      isSuccess: isResetPasswordSuccess,
      isError: isResetPasswordError,
      error: errorResetPassword,
    },
  ] = useResetPasswordMutation();

  const [timeLeft, setTimeLeft] = useState(0);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (timeLeft === 0) return;
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  useEffect(() => {
    if (isSuccess && recoveryData) {
      resetPasswordMutation({
        recoveryCode: recoveryData.data[0].recoveryCode,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  useEffect(() => {
    if (isResetPasswordSuccess) {
      toast({
        title: "Reset password email sent",
        description: "Please check your email to reset your password.",
        status: "success",
        duration: 6000,
        isClosable: true,
        position: "top-right",
      });
      setTimeLeft(60);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isResetPasswordSuccess]);

  useEffect(() => {
    if (isError && errorRecovery) {
      setErrors({
        email:
          (errorRecovery as any)?.data?.errors
            ?.map((err: any) => err.message)
            ?.join(", ") || "Something went wrong!",
      });
    }
  }, [isError, errorRecovery]);

  useEffect(() => {
    if (isResetPasswordError && errorResetPassword) {
      setErrors({
        email:
          (errorResetPassword as any)?.data?.errors
            ?.map((err: any) => err.message)
            ?.join(", ") || "Something went wrong!",
      });
    }
  }, [isResetPasswordError, errorResetPassword]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = async () => {
    try {
      await emailSchema.validate(formData, { abortEarly: false });
      setErrors({});
      return true;
    } catch (err) {
      const validationErrors = {};
      err.inner.forEach((error) => {
        validationErrors[error.path] = error.message;
      });
      setErrors(validationErrors);
      return false;
    }
  };

  const onSubmit = async () => {
    const isValid = await validateForm();
    if (isValid) {
      recovery({
        email: formData.email,
      });
    }
  };

  return (
    <Center
      className="Login"
      w="100%"
      h={["calc(100% - 60px)", null, "100%"]}
      overflow="auto"
      mt="0 !important"
      p={["24px 15px", null, 0]}
    >
      <Flex
        flexDir="column"
        h="100%"
        w={["100%", "364px"]}
        justify={["flex-start", null, "center"]}
      >
        <Text
          textTransform={"uppercase"}
          textAlign="center"
          textStyle="h1"
          mb={"30px"}
        >
          Forgot Password
        </Text>
        <FormControl isInvalid={errors.email} mb="32px">
          <FormLabel>Email</FormLabel>
          <Input
            name="email"
            data-testid="email-input-forgot"
            isRequired
            onChange={handleChange}
          />
          {errors.email && (
            <FormErrorMessage data-testid="email-error" fontSize={12}>
              {errors.email}
            </FormErrorMessage>
          )}
        </FormControl>
        <Button
          data-testid="button-login-forgot"
          onClick={onSubmit}
          isLoading={isSubmitting || isLoading || isResetPasswordLoading}
          type="submit"
          variant="solid"
          colorScheme="blue"
          w="100%"
          h="38px"
          disabled={timeLeft !== 0}
        >
          <Text textStyle="input-label" fontWeight="600" color={"white"}>
            {timeLeft ? `${timeLeft}s` : "Submit"}
          </Text>
        </Button>
        <Button
          data-testid="button-back-forgot"
          marginTop={"20px"}
          disabled={timeLeft !== 0}
          type="submit"
          width="full"
          onClick={() => {
            push("/");
          }}
        >
          Back
        </Button>
        {/* Fake bottom padding */}
        <Box w="100%" minH="24px" />
      </Flex>
    </Center>
  );
};

export default Forgot;
